<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cập nhật Phân hệ: {{ modelData.name }}</h2>
        <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button>
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="24">
          <el-form label-position="top" :model="modelData" ref="createModel" label-width="135px" @submit.native.prevent>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item prop="name" label="Tên Phân hệ" class="form-item"
                  :rules="[
                    { required: true, message: 'Vui lòng nhập tên Phân hệ', trigger: 'blur' }
                  ]">
                  <el-input v-model="modelData.name" class="input-seach" ref="myInput"></el-input>
                </el-form-item>
                <el-form-item prop="school_ids" label="Chọn trường học" class="form-item">
                  <el-select v-model="modelData.school_ids" filterable multiple placeholder="" class="input-select-2">
                    <el-option
                      v-for="item in lists.listSchool"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="priority" label="Vị trí ưu tiên" class="form-item">
                  <el-input v-model="modelData.priority" class="input-seach"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="Kích hoạt" prop="status">
              <el-switch
                active-color="#13ce66"
                inactive-color="#7f8c8d"
                v-model="modelData.status">
              </el-switch>
            </el-form-item>
            <el-form-item>
                <el-button
                  :disable="!canSubmit"
                  :loading="!canSubmit"
                  type="warning"
                  size="small"
                  @click="submitForm('createModel')"
                  native-type="submit">Cập nhật</el-button>
                <el-button
                  size="small"
                  class="btn-back"
                  @click="backModel">Trở về
                </el-button>
              </el-form-item>
          </el-form>
        </el-col>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
import tinymce from 'vue-tinymce-editor'
export default {
  name: 'CategoryBlogUpdate',
  metaInfo () {
    return {
      title: 'Phân hệ'
    }
  },
  components: {
    tinymce
  },
  data () {
    return {
      canSubmit: true,
      activeName: 'first',
      modelData: {
        name: '',
        school_ids: [],
        priority: 0,
        status: true
      },
      tinymce: {
        toolbar1: 'undo redo formatselect fontsizeselect | bold italic strikethrough forecolor backcolor | link image media | alignleft aligncenter alignright alignjustify | numlist bullist outdent indent'
      },
      lists: {
        listSchool: [],
        listLevel: [],
        listFacult: [],
        listSpecialized: []
      },
      listCategories: []
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
    this.fetchSchool()
  },
  methods: {
    handleImageAdded: async function (file, success, failure) {
      // images_upload_handler: handleImageAdded // Vứt vào đoạn option cạnh chữ 500px
      let formData = new FormData()
      formData.append('file', file.blob())
      let response = await axios.post('levels/upload-not-resize', formData)
      if (response.code === 1) {
        success(response.data.path_sm)
      } else {
        return false
      }
    },
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'levels-index', text: 'Phân hệ' },
        { name: 'levels-update', text: 'Cập nhật' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'levels-index'})
    },
    // Tải dữ liệu
    fetchSchool () {
      let data = {
        'status': 1,
        'limit': -1
      }
      axios.get('schools', {params: data}).then(response => {
        switch (response.code) {
          case 200:
            this.lists.listSchool = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('levels/' + this.$route.params.level_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.updateModel()
        } else {
          console.log('Lỗi validate')
          return false
        }
      })
    },
    updateModel () {
      this.canSubmit = false
      axios.put('levels/' + this.$route.params.level_id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            this.$router.push({name: 'levels-index'})
            // this.$router.push({name: 'levels-show', params: {id: this.$route.params.id}})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/levels/Update.vue